import { Component, OnInit } from '@angular/core';
import {
  ServicioImprimirAdmisionService,
  ParametrosImprimirAdmisionEntity,
  EntidadEmpresarial,
  InformacionUsuarioEntity
} from 'src/app/services/servicio-imprimir-admision.service';
import { ServicioRecordatorioCitasService, RecordatorioCitasEntity } from 'src/app/services/servicio-recordatorio-citas.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-reporte-recordatorio-citas-s',
  templateUrl: './reporte-recordatorio-citas-s.component.html',
  styleUrls: ['./reporte-recordatorio-citas-s.component.css']
})
export class ReporteRecordatorioCitasSComponent implements OnInit {
  private parametrosUrl: ParametrosImprimirAdmisionEntity = {
    codigoBaseDatos: '',
    uncoSede: '',
    uncoLogin: '',
    uncoAdmision: ''
  };

  public errorDataReporte = false;
  public loading = true;
  public error = false;
  public fechaImpresion: Date = new Date();
  public uncoCirugia: string;
  public dataEntidadEmpresarial: EntidadEmpresarial = {
    identificacionTributaria: '',
    digitoVerificacion: '',
    descripcion: '',
    direccion: '',
    telefono: '',
    logoUrl: '',
    codigoPrestador: ''
  };
  public dataUsuario: InformacionUsuarioEntity = {
    nombreUsuario: '',
    codigoBarrasImprime: ''
  };
  // public dataReporte: RecordatorioCitasEntity[] = [];
  public dataReporte: RecordatorioCitasEntity = {
    sede: '',
    puntoAtencion: '',
    profesionalSalud: '',
    identificacionAfiliado: '',
    afiliado: '',
    telefonoAfiliado: '',
    periodoInical: '',
    duracion: '',
    fechaCita: '',
    mes: '',
    dia: '',
    autorizacionConsultaExterna: '',
    empresa: '',
    procedimiento: '',
    codigoProcedimiento: '',
    tipoDocumento: '',
    direccionSede: '',
    telefonoMovil: '',
    telefonoPbx: '',
    tipoHora: '',
    detalleCita: ''
  };

  constructor(
    private servicioAdmision: ServicioImprimirAdmisionService,
    private servicioRecordatorio: ServicioRecordatorioCitasService,
    private activatedRoute: ActivatedRoute
  ) {
    this.activatedRoute.params.subscribe( (params: any) => {
      this.parametrosUrl.codigoBaseDatos = params.codigoBaseDatos;
      this.parametrosUrl.uncoSede = params.uncoSede;
      this.parametrosUrl.uncoLogin = params.uncoLogin;
      this.uncoCirugia = params.uncoCirugia;
    });
  }

  ngOnInit() {
    this.getInfoEntidadEmpresarial();
    this.getDataRecordatorioCitas();
    this.getInfoUsuario();
  }

  public getPrint() {
    window.print();
  }

  /* Consumo de servicios */

  private async getInfoEntidadEmpresarial() {
    const response = await this.servicioAdmision.getEntidadEmpresarial(this.parametrosUrl);

    response.subscribe( (data: any) => {
      if (data != null) {
        this.dataEntidadEmpresarial = data[0];
      }
      // console.log(this.dataEntidadEmpresarial);
    }, error => {
      this.errorDataReporte = true;
      this.loading = false;
      console.log(error);
    });
  }

  private async getInfoUsuario() {
    const response = await this.servicioAdmision.getInformacionUsuario(this.parametrosUrl);

    response.subscribe( (data: any) => {
      if (data != null) {
        this.dataUsuario = data[0];
      }
      // console.log(this.dataUsuario);
    }, error => {
      this.errorDataReporte = true;
      this.loading = false;
      console.log(error);
    });
  }

  private async getDataRecordatorioCitas() {
    const response = await this.servicioRecordatorio.getDataRecordatorioCitas(this.parametrosUrl.codigoBaseDatos, this.uncoCirugia);

    response.subscribe( (data: any) => {
      if (data != null) {
        this.dataReporte = data[0];
        this.loading = false;
      }
      console.log(this.dataReporte);
    }, error => {
      this.errorDataReporte = true;
      this.loading = false;
      console.log(error);
    });

  }

}
